import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getColor from "@insite/mobius/utilities/getColor";

savedOrderListTableStyles.dataTable = mergeToNew(savedOrderListTableStyles.dataTable, {
    cssOverrides: {
        evenRow: css`
            background: #FFFFFF;
        `,
    }
});

savedOrderListTableStyles.orderDateHeader = mergeToNew(savedOrderListTableStyles.orderDateHeader, {
    css: css`
        background: ${getColor("secondary")};
        > [class^="StyledButton"] {
            &:focus {
                outline: none;
            }
        }
    `,
});

savedOrderListTableStyles.shipToLabelHeader = mergeToNew(savedOrderListTableStyles.shipToLabelHeader, {
    css: css`
        background: ${getColor("secondary")};
        > [class^="StyledButton"] {
            &:focus {
                outline: none;
            }
        }
    `,
});

savedOrderListTableStyles.subtotalHeader = mergeToNew(savedOrderListTableStyles.subtotalHeader, {
    css: css`
        background: ${getColor("secondary")};
        > [class^="StyledButton"] {
            &:focus {
                outline: none;
            }
        }
    `,
});
